import initiateBlockGeneration from './initiate-block-generation';
import initiatePageGeneration from './initiate-page-generation';
import initiatePageReplacement from './initiate-page-replacement';
import initiatePageTranslation from './initiate-page-translation';
import initiateTextGeneration from './initiate-text-generation';
import initiateTextReplacement from './initiate-text-replacement';
import getUnsplashSearchQuery from './get-unsplash-search-query';

export default {
  initiateBlockGeneration,
  initiatePageGeneration,
  initiatePageReplacement,
  initiatePageTranslation,
  initiateTextGeneration,
  initiateTextReplacement,
  getUnsplashSearchQuery,
};
